import { inject, Injectable, DOCUMENT } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private document = inject<Document>(DOCUMENT);


    switchTheme(theme: string) {
        // PrimeNG 19 : le mode sombre s'active via la classe définie par darkModeSelector ('.biifor-dark')
        const isDark = theme.includes('dark');
        this.document.documentElement.classList.toggle('biifor-dark', isDark);
    }

}